import { render, staticRenderFns } from "./TableEvents.vue?vue&type=template&id=f4ba83dc&scoped=true&"
import script from "./TableEvents.vue?vue&type=script&lang=js&"
export * from "./TableEvents.vue?vue&type=script&lang=js&"
import style0 from "./TableEvents.vue?vue&type=style&index=0&id=f4ba83dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ba83dc",
  null
  
)

export default component.exports